<template lang="pug">
  include ../mixins
  div(ref="youtube-wrapper")
    +b.square-container.--flex_end.ma--top_md-md.video-block(@click.prevent="openVideo")
      +e.square.--radius_none.--size_1.pos--relative.z-index--1(v-if="!isOpen")
        +b.video-overlay
          +e.play-btn
            +b.I.ls-icon.--type_play
        picture
          +e.IMG.img-absolute(:src="preview")
      +e.square.--radius_none.--size_1.pos--relative(v-show="isOpen")
        +e.YOUTUBE.video-absolute(
          ref="youtube"
          :video-id="videoId"
        )
    +b.ma.--top_3sm.u-display--hidden-xl
      +b.timeline
        +e.item(
          v-for="item in timeline"
          @click.prevent="seekTo(item.time_label)"
        )
          +e.time
            +b.P.ls-text.--color_accent-1.--size_2xs.--weight_semi-bold {{ item.time_label }}
          +e.title
            +b.P.ls-text.--color_main.--size_2xs {{ item.title }}
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import VueYoutube, { getIdFromUrl } from 'vue-youtube'

Vue.use(VueYoutube)
export default {
  props: {
    video: {
      type: String,
    },
    preview: {
      type: String,
    },
    timeline: {
      type: Array,
    },
  },

  data() {
    return {
      videoId: getIdFromUrl(this.video),
      isOpen: false,
    }
  },

  computed: {
    player() {
      return this.$refs.youtube.player
    },
  },

  mounted() {
    document.addEventListener('seekTo', data => {
      const { detail: { time } } = data

      this.seekTo(time)
    })
  },

  methods: {
    openVideo() {
      this.isOpen = true
      this.player.playVideo()
    },

    seekTo(time) {
      if (!this.isOpen) {
        this.openVideo()
      }

      const seconds = moment.duration(time).asSeconds()

      this.player.seekTo(seconds)

      this.scrollToVideo()
    },

    scrollToVideo() {
      const node = this.$refs['youtube-wrapper']
      node.scrollIntoView()
    },
  },
}
</script>
